/* eslint-disable no-dupe-keys */
export default {
  operation_activity: {
    titles: {
      base_info: '基本信息'
    },
    name: '运营活动',
    enabled: '已启用',
    disabled: '已停用',
    status_update_success: '状态更新成功！',
    // 属性
    prop: {
      name: '名称',
      activity_type: '类型',
      begin_time: '开始时间',
      effective_time: '有效期',
      end_time: '结束时间',
      inviter_reward: '邀请人奖励',
      invitee_reward: '应邀人奖励',
      inviter_reward_type: '邀请人奖励类型',
      invitee_reward_type: '应邀人奖励类型',
      inviter_reward_point: '积分',
      inviter_reward_cash: '现金',
      inviter_reward_coupon: '优惠券',
      invitee_reward_coupon: '优惠券',
      picture: '活动图片',
      poster: '邀请海报图片',
      status: '状态',
      valid_time: '有效期',
      rule_description: '活动规则描述',
      activity_participations_count: '参与次数',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // （search display）
    paramLocales: {
      name: '名称',
      valid_time: '有效期',
      activity_types: '活动类型',
      begin_time: '开始时间',
      end_time: '结束时间',
      inviter_reward: '邀请人奖励',
      invitee_reward: '应邀人奖励',
      status: '状态',
      rule_description: '活动规则描述'
    },
    // 列表页字段
    columns: {
      activity_types: '活动类型'
      // rule_description: '活动规则描述'
    },
    // Enum的属性
    activity_types: {
      invite_user: '邀请用户',
      sign_in: '签到'
    },
    reward_types: {
      point: '积分',
      cash: '现金',
      coupon: '优惠券'
    },
    statuses: {
      pending: '待生效',
      available: '生效中',
      expired: '已过期',
      disabled: '已停用'
    },
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      participations: '活动参与记录'
    }
  }
}
